import { graphql } from 'gatsby'
import { useShopStoreIncontext } from '../../context/shopContext'
import Link from '../Link'
import { getNavData, getSubNavData, useNavData } from './useNavData'

import AusFlag from './LocalisationSelector/flags/aus.svg'
import NZFlag from './LocalisationSelector/flags/nz.svg'
import UKFlag from './LocalisationSelector/flags/uk.svg'
import USAFlag from './LocalisationSelector/flags/usa.svg'

import styled from '@emotion/styled'
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import bagWhite from '../../images/icons/bag-white.svg'
import bag from '../../images/icons/bag.svg'
import EmptyHeart from '../../images/empty-heart-thin.svg';


import { Global, css } from '@emotion/react'
import july from '../../images/icons/logo.svg'
import julyWhite from '../../images/icons/logo-white.svg'

import NavigationMenu from '../../components/defaultStorycomponents/NavigationMenu'
import HamburgerAnimated from './HamburgerAnimated'
import SearchBar from './Search/search-bar'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import DesktopMenu from './DesktopMenu'
import useEmblaCarousel from 'embla-carousel-react'
import {
  PrevButton,
  NextButton,
} from '../panels/Button/EmblaCarouselArrowButtons'
import { EmBlaCarouselArrowButtons } from '../panels/Button/EmblaCarouselArrowButtons'
import Autoplay from 'embla-carousel-autoplay'
import useFavoriteProducts from '../../hooks/useFavoriteProducts'

const luggageFinder = 'to'

const MenuOffset = styled.div`
  height: ${(props) => (props.height ? `${props.height}px` : '60px')};
  @media (min-width: 950px) {
    ${({ showOffset }) => showOffset ? 'height: 60px;' : 'height: 0;'}
  }
`

const SectionContainerTop = styled.div`
  height: ${(props) => (props.height ? `${props.height}px` : '60px')};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 999;
  background-color: ${(props) => (props.atTop ? 'transparent' : 'white')};

  @media (max-width: 950px) {
    background-color: white;
  }

  ${(props) => !props.visible && `top: -160px;`}
  transition: background-color 0.3s ease-in-out, top 0.3s ease-in-out;
  :root {
    --menu-offset: ${(props) => (props.showRibbon || props.mobileAtTop ? '113px' : '60px')};
  }
`
const BackgroundContainer = styled.div`
  position: absolute;
  display: flex;
  inset: 0;
`

const LogoContainerImage = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 90px;
`
const LogoContainer = styled.div`
  position: relative;
  height: 64px;
  width: 90px;
`

const Menu = styled.div`
  // position: absolute;
  // left: 0;
  // top: 0;
  // bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  & a {
    text-decoration: none;
    color: #1f3e3c;
  }
  @media (max-width: 950px) {
    flex-direction: row-reverse;
    width: 80%;
    justify-content: flex-end;
  }
`
const CartContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 950px) {
    margin-right: 32px;
  }
  @media (max-width: 950px) {
    margin-right: 16px;
  }
`
const Cart = styled.div`
  position: relative;
  cursor: pointer;
`
const Search = styled.div`

`
const ImageContainer = styled(Link)`
  @media (max-width: 950px) {
    position: absolute;
    left: calc(50% - 45px);

  }
`
const IconOutline = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  border: 1px solid ${({ atTop }) => (atTop ? 'white' : 'black')};
  border-radius: 50%;
  display: flex;
  align-items: center;
`

const CartIndicator = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  ${({ white }) =>
    white
      ? `
    background-color: white;
    color: black;
  `
      : `
    background-color: black;
    color: white;
  `}
  border-radius: 50%;
  font-size: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  font-weight: 600;
`

const IconContainer = styled.div`
  position: relative;
  width: 64px;
  margin-left: 16px;
  height: 64px;
  cursor: pointer;
  @media (max-width: 950px) {
    margin-left: 16px;
  }
  @media (min-width: 950px) {
    display: none;
  }
`
const LogoImage = styled(GatsbyImage)`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: opacity 0.3s ease-in-out;
`
const LogoImg = styled.img`
  position: absolute;
  width: 100%;
  height: 45%;
  object-fit: contain;
  transition: opacity 0.3s ease-in-out;
`
const IconImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: opacity 0.3s ease-in-out;
`

const useThrottledScroll = (handleOnScroll) => {
  const rafRef = useRef(null)
  const lastInvocationTimeRef = useRef(null)

  const handleScroll = () => {
    const now = typeof window !== 'undefined' ? Date.now() : 0
    if (
      !lastInvocationTimeRef.current ||
      now - lastInvocationTimeRef.current > 10
    ) {
      cancelAnimationFrame(rafRef.current) // Always clear previous frame requests
      rafRef.current = requestAnimationFrame(() => {
        handleOnScroll()
        lastInvocationTimeRef.current = now
      })
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      cancelAnimationFrame(rafRef.current)
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
}

const GlobalRibbonBanner = styled(Link)`
  display: block;
  font-size: 14px;
  text-align: center;
  line-height: 2.1;
  padding-top: 4px;
  font-weight: 400;
  color: ${({textColor}) => textColor};
  background-color: ${({BGcolor}) => BGcolor};
`

const Embla = styled.div`
  overflow: hidden;
  position: relative;
  & .slick-prev, .slick-next {
    height: 10px;
    width: 10px;
  }
`

const DesktopPrevButton = styled(PrevButton)`
  @media (max-width: 950px) {
    display: none !important;
  }
`

const DesktopNextButton = styled(NextButton)`
  @media (max-width: 950px) {
    display: none !important;
  }
`

const StoreLink = styled(Link)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 16px;
  font-size: 12px;
  color: white;
  display: flex;
  align-items: center;
  color: ${({textColor}) => textColor};
  transition: color 0.3s ease-in-out;
  @media (max-width: 950px) {
    display: none;
  }

`

const EmblaContainer = styled.div`
  display: flex;


  .embla__slide {
    flex: 0 0 100%;
    min-width: 0;
  }
`

const IconHeart = styled.img`
  height: 25px;
  cursor: pointer;
  z-index: 3;
`

const flagImage = {
  'en-AU': AusFlag,
  en: USAFlag,
  'en-NZ': NZFlag,
  'en-GB': UKFlag,
}
const getFlagImage = (locale) => flagImage[locale]

const FlagImage = styled.img`
  height: 28px;
  margin-right: 8px;
  padding-bottom: 0px;
`

const matchProductPage = (pathname) => {
  const splitPath = pathname.split('/')
  if (
    splitPath[2] &&
    ((['travel-bags', 'travel-accessories', 'luggage', 'products'].includes(
      splitPath[2]
    ) &&
      splitPath[3]) ||
      ['the-details', 'olympics-giveaway'].includes(splitPath[2]))
  ) {
    return true
  }
  return false
}

const matchMenuOffset = (pathname) => {
  const splitPath = pathname.split('/')
  if (
    (splitPath[2] &&
      [
        'tote-bags-collection',
        'weekender-bags-collection',
        'backpacks-collection',
        'crossbody-bags-collection',
        'travel-accessories-lifestyle',
        'carry-all-collection',
        'daybreak-collection',
        'volume-plus-collection',
        'light-luggage-collection',
        'classic-luggage-collection',
        'checked-luggage-collection',
        'carry-on-luggage-collection',
        'faqs',
        'everyday-tote',
        'shop',
        'personalisation',
        'contact-us',
        'tracking',
        'final-call',
        'virtual-consultation',
        'affiliate-program',
        'valentines-day-edit',
        'trunk-luggage-collection',
        'lunar-new-year',
        'search',
        'july-vs-monos-carry-on',
        'press-pack',
        'jobs',
        'terms-conditions',
        'privacy-policy',
        'july-vs-away-carry-on',
        'weekender-promo',
        'compare',
        'olympics-giveaway',
        'reviews',
        'mothers-day',
        'bundle-sets',
        'luggage-cover-promo',
        'memorial-day',
        'giveaway-coreplus',
        'bundle-builder',
      ].includes(splitPath[2])) ||
    pathname.includes('compare')
  ) {
    return true
  }
  return false
}

function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState(0)

  useEffect(() => {
    setWindowWidth(window.innerWidth)

    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    const debounceResize = debounce(handleResize, 200)

    window.addEventListener('resize', debounceResize)

    handleResize()

    return () => {
      window.removeEventListener('resize', debounceResize);
    }
  }, [])

  return windowWidth
}

// Debounce function implementation
function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

const menuStates = [
  'transparent-white',
  'transparent-black',
  'hidden',
  'block'
]

const mobileCutoff = 750

const Header = ({ data, pathname, navStyle }) => {
  const windowWidth = useWindowWidth()
  const { cart, setCartOpen, setMenuOpen, menuOpen, storeLocale } =
    useShopStoreIncontext((state) => {
      return {
        cart: state.cart,
        setCartOpen: state.actions.setCartOpen,
        setMenuOpen: state.actions.setMenuOpen,
        menuOpen: state.menuOpen,
        storeLocale: state.storeLocale,
      }
    })

  const isMobile = windowWidth <= mobileCutoff
  let offsetMenu = matchMenuOffset(pathname)
  let alwaysBlack = matchProductPage(pathname) || offsetMenu

  const [shouldShow, setShouldShow] = useState(true)
  const [atTop, setAtTop] = useState(true)

  const [showRibbon, setShowRibbon] = useState(true)

  const lastScrollRef = useRef(null)

  const checkScreenPos = () => {
    const currentScroll = window.scrollY
    if (currentScroll > lastScrollRef.current && !(currentScroll < 200)) {
      setShouldShow(false)
    } else {
      setShouldShow(true)
    }
    setAtTop(currentScroll < (isMobile ? 60 : 200))
    setShowRibbon(currentScroll < 40)
    lastScrollRef.current = currentScroll
  }

  useThrottledScroll(checkScreenPos)

  useEffect(() => {
    checkScreenPos()
  }, [pathname])

  const { strapiNavigation } = useNavData(data)
  const [subNavData] = useState(getSubNavData(strapiNavigation))
  const [navData] = useState(getNavData(strapiNavigation))

  const topLevelNavData = [
    ...navData.map((navDataItem) => ({
      ...navDataItem,
      title: navDataItem.text,
    })),
  ]
  const menuData = [
    ...subNavData.map((subNavItem) => {
      return {
        ...subNavItem,
        items: subNavItem.subItems,
      }
    }),
  ]

  let item_count = 0
  cart?.map((item) => {
    return (item_count += item?.variantQuantity)
  })
  const navigationMenuRef = useRef(null)

  const handleMouseEnter = () => {
    setMenuOpen(!menuOpen)
  }

  const [hoveredDesktopMenuCategory, setHoveredDesktopMenuCategory] =
    useState(undefined)

  let menuState = ''
  if (
    atTop &&
    !offsetMenu &&
    hoveredDesktopMenuCategory === undefined &&
    !menuOpen &&
    !isMobile
  ) {
    if (alwaysBlack) {
      menuState = 'transparent-black'
    } else {
      menuState = 'transparent-white'
    }
  } else {
    menuState = 'block'
  }
  if (hoveredDesktopMenuCategory === undefined && !isMobile) {
    if (navStyle === 'transparent_white') {
      menuState = 'transparent-white'
    } else if (navStyle === 'transparent_black') {
      menuState = 'transparent-black'
    } else if (navStyle === 'solid_black') {
      menuState = 'block'
      offsetMenu = true
    }
  }
  if (pathname.includes('2024-test-homepage')) {
    menuState = 'transparent-white'
    offsetMenu = false
  }

  menuState = 'block'
  offsetMenu = true

  const visible = shouldShow || menuOpen || hoveredDesktopMenuCategory !== undefined

  const [emblaRef, emblaApi] = useEmblaCarousel({
    slidesToScroll: 1,
    align: 'center',
    skipSnaps: false,
    dragFree: false,
    loop: true,
    containScroll: 'keepSnaps',
  }, [
    Autoplay({ playOnInit: true, delay: 3000 })
  ])

  const [currentIndex, setCurrentIndex] = useState(0);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCurrentIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi, setCurrentIndex]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on('select', onSelect);
    return () => {
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi, onSelect]);


  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = EmBlaCarouselArrowButtons(emblaApi)

  const [favoriteProducts, addFavoriteProduct, removeFavoriteProduct] = useFavoriteProducts();

  return (
    <>
      <Global styles={css`
        :root {
          --menu-offset: ${showRibbon || (isMobile && atTop) ? '93px' : '60px'};
          --pdp-offset: ${!visible ? '16px': ((showRibbon || (isMobile && atTop)) ? '99px' : '66px')};


        }
      `} />
      {
        // tickerRibbon && storeLocale !== 'en-GB' && storeLocale !== 'en' ? (
        //   <TickerTopRibbon />
        // ) : (
        //   <GlobalRibbonBanner to={strapiNavigation?.GlobalRibbonBannerLink} textColor={strapiNavigation?.GlobalRibbonBannerTextColour} BGcolor={strapiNavigation?.GlobalRibbonBannerColour}> {strapiNavigation?.GlobalRibbonBannerText} </GlobalRibbonBanner>
        // )
        <Embla ref={emblaRef}>
          <EmblaContainer>
            {data?.strapiNavigation?.RibbonBanners.map((item, index) => {
              return (
                <GlobalRibbonBanner
                  key={index}
                  to={item?.Link}
                  textColor={item?.textColor}
                  BGcolor={item?.bgColor}
                  className="embla__slide"
                >
                  {' '}
                  {item?.Text}{' '}
                </GlobalRibbonBanner>
              )
            })}
          </EmblaContainer>
          {data?.strapiNavigation?.RibbonBanners?.length > 0 && (
            <>
              <DesktopPrevButton
                style={{ left: '25%', top: '10px' }}
                onClick={onPrevButtonClick}
                disabled={prevBtnDisabled}
                buttonColor="light"
                color={data?.strapiNavigation?.RibbonBanners[currentIndex]?.textColor}
              />
              <DesktopNextButton
                style={{ right: '25%', top: '10px' }}
                onClick={onNextButtonClick}
                disabled={nextBtnDisabled}
                buttonColor="light"
                color={data?.strapiNavigation?.RibbonBanners[currentIndex]?.textColor}
              />
            </>
          )}
          <StoreLink
            textColor={
              data?.strapiNavigation?.RibbonBanners[currentIndex]?.textColor
            }
            to="/store"
          >
            Stores
          </StoreLink>
        </Embla>
      }
      <SectionContainerTop visible={visible} atTop={menuState !== 'block'} isMobile={isMobile} showRibbon={showRibbon} mobileAtTop={isMobile && atTop} height={60} top={33}>
        <Menu>
          <ImageContainer to="/">
            <LogoContainerImage>
              {
                menuState === 'transparent-white' ? (
                  <LogoImg
                    src={julyWhite}
                    alt={'Logo White'}
                  />
                ) : (
                  <LogoImg
                    src={july}
                    alt={'Logo Default'}
                  />
                )
              }
            </LogoContainerImage>
          </ImageContainer>

          <IconContainer
            onClick={handleMouseEnter}
          >
            <HamburgerAnimated
              color={menuState === 'transparent-white' ? 'white' : 'black'}
              open={menuOpen}
            />
            {/* <IconImage src={(menuState === 'transparent-white') ? menuWhite : menu} alt={'menu'} /> */}
          </IconContainer>
          <DesktopMenu
            menuData={menuData}
            topLevelNavData={topLevelNavData}
            menuState={menuState}
            setHoveredDesktopMenuCategory={setHoveredDesktopMenuCategory}
            hoveredDesktopMenuCategory={hoveredDesktopMenuCategory}
          />
        </Menu>
        <CartContainer>
          <div className="mr cursor-pointer">
            <SearchBar white={menuState === 'transparent-white'} />
          </div>
          <div className="mr-4 cursor-pointer relative">
            <Link to="/wishlist">
              <IconHeart src={EmptyHeart} alt="empty heart" />
              {favoriteProducts.length > 0 && (
                <CartIndicator white={menuState === 'transparent-white'}>
                  {favoriteProducts.length}
                </CartIndicator>
              )}
            </Link>
          </div>
          <Cart
            onClick={() => {
              setCartOpen(true)
            }}
          >
            <IconOutline atTop={menuState === 'transparent-white'}>
              <img
                src={menuState === 'transparent-white' ? bagWhite : bag}
                alt={'cart'}
                style={{
                  width: 40,
                  height: 40,
                  objectFit: 'contain',
                  padding: 6,
                }}
              />
            </IconOutline>
            {item_count > 0 && (
              <CartIndicator white={menuState === 'transparent-white'}>
                {item_count}
              </CartIndicator>
            )}
          </Cart>
        </CartContainer>
      </SectionContainerTop>
      <NavigationMenu
        handleClose={handleMouseEnter}
        ref={navigationMenuRef}
        data={{ menuItems: menuData, luggageFinder, topLevelNavData }}
        menuOpen={menuOpen}
      />
    </>
  )
}

export default Header

export const query = graphql`
  query ($locale: String) {
    strapiNavigation(locale: { eq: $locale }) {
      locale

      RibbonBanners {
        Text
        Link
        textColor
        bgColor
      }

      NavCategories {
        CategoryName
        Highlight
        to
        Items {
          NavImage {
            ...Image
          }
          text
          to
          isTitle
          new
          restocked
          ItemLabel
        }

        Tiles {
          TileImage {
            file {
              childImageSharp {
                gatsbyImageData(width: 200)
              }
            }
          }
          TileTitle
          TitleDescription
          link
        }

        QuizTitle
        QuizLink
      }
      NavBarLinks {
        NewTab
        text
        to
      }
    }
    julyOlympicsWhite: file(
      relativePath: { eq: "icons/nav-olympic-logo-white.png" }
    ) {
      childImageSharp {
        gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        gatsbyImageDataMobile: gatsbyImageData(
          quality: 85
          placeholder: NONE
          width: 550
        )
      }
    }
    julyOlympicsNonAU: file(
      relativePath: { eq: "icons/july-olympic_nonau_black.png" }
    ) {
      childImageSharp {
        gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        gatsbyImageDataMobile: gatsbyImageData(
          quality: 85
          placeholder: NONE
          width: 550
        )
      }
    }
    julyOlympicsWhiteNonAU: file(
      relativePath: { eq: "icons/july-olympic_nonau_white.png" }
    ) {
      childImageSharp {
        gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        gatsbyImageDataMobile: gatsbyImageData(
          quality: 85
          placeholder: NONE
          width: 550
        )
      }
    }
  }
`
